import RoadsApi from '@/services/api/Roads'
import MapBuilder from '../services/MapBuilder'
import MapBox from '../services/MapBox'

export default {
  name: 'road',
  props: {
    siteName: String
  },
  data() {
    return {
      breadcrumbs:[],
      roadName: this.$route.params.roadname.replace('-', ' '),
      inMyMap: null,
      roadDetails: {
        geoJson: {
          name:''
        }
      }
    }
  },
  async mounted () {
    // load mapbox
    await this.$loadScript('https://api.mapbox.com/mapbox-gl-js/v1.0.0/mapbox-gl.js');
    await this.loadRoadDetails();
    
    this.inMyMap = MapBuilder.isRoadInMyMap(this.roadDetails);

    this.buildMap();

    let {town} = this.$route.params;

    this.breadcrumbs = [
      {
        text: this.siteName,
        disabled: false,
        href: '/'
      },
      {
        text: 'towns', // Town Name
        disabled: false,
        href: `/towns`
      },
      {
        text: this.$route.params.town, // Town Name
        disabled: false,
        href: `/towns/${town}`
      },
      {
        text: this.roadName,
        disabled: true
      }
    ];
  },
  methods: {
    async loadRoadDetails() {
      let {town,roadname} = this.$route.params;
      let road = await RoadsApi.getRoadDetail(town, roadname);
      this.roadDetails = road;

      // console.log(this.roadDetails);
    },

    buildMap() {
      let map = MapBox.createMap();

      let roadGeo = this.roadDetails.geoJson,
          mapBounds = MapBox.getMapBounds(this.roadDetails.geoJson);

      map.on('load', () => {
          map.fitBounds(mapBounds, { padding: 60, duration: 0 });

        // road layer
        map.addLayer({
            'id': 'road',
            'type': 'line',
            'source': {
              'type': 'geojson',
              'data': roadGeo
            },
            'paint': {
              'line-color': '#06D6A0',
              'line-width': 3,
              'line-opacity': .5
            }
        });
      });
    },
    
    toggleMyMap() {
      if (this.inMyMap) {
        MapBuilder.removeRoad(this.roadDetails);
        this.inMyMap = false;
      } else {
        MapBuilder.addRoad(this.roadDetails);
        this.inMyMap = true;
      }
    }
  }
}